import { FC } from 'react';
import { Link } from "react-router-dom";
import Banners  from "../../containers/banner";
import './policy.scss';

interface PageProps {
    title: string;
}

const NeospectraPrivacy:FC<PageProps> = ({title}) => {
    return (
        <div className="">
            <Banners title={title} />
            <div className='row'>
                <div className="container">
                    <div className="cont-agg-all">
                        <section id="제1조">
                            <div>
                            ㈜네오스펙트라 (이하 "회사"라 합니다)는 이용자들의 개인정보를 소중하게 생각하며, 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법규를 준수하고 있습니다. 회사는 이용자의 개인정보 보호를 위해 다음과 같은 개인정보 처리방침을 수립하여 공개합니다.
                            </div>
                            <h3>제1조 (개인정보의 처리 목적)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                회사는 다음과 같은 클라우드서비스 제공을 목적으로 필요에 의한 최소한으로 수집된 개인정보를 처리합니다. 처리된 개인정보는 아래 명시된 목적 외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br></br>                     
                                1 사용자 인증 및 서비스 제공: ㈜올포랜드의 포털서비스(https://www.mapprime.co.kr/)를 통해 가입한 사용자가 회사의 AI 데이터 생성관리 서비스(https://neospectra.io/)에 접속 시, <br />
                                사용자 식별 및 인증을 통해 서비스 이용 권한을 확인합니다.<br />   
                                2 서비스 운영 및 개선: 서비스 이용 기록 분석 (아이디, 호출한 API, 요청 시간, 응답 시간)을 통해 서비스 품질을 향상시키고, 오류 발생 시 원인을 분석하여 개선합니다.<br />      
                                3 서비스 성능 측정 및 통계 분석을 통해 사용자 경험을 최적화하고, 향후 서비스 개발 방향을 설정하는 데 활용합니다.<br />
                                </li>
                            </ul>
                        </section>

                        <section id="제2조">
                            <h3>제2조 (처리하는 개인정보의 항목 및 수집 방법)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                회사는 다음과 같은 개인정보 항목을 다음의 방법으로 처리합니다.
                                ㈜올포랜드로부터 제공받는 정보 (사용자 인증 시)
                                <div className="table cs-table-line">
                                    <table>
                                        <colgroup>
                                            <col className="width140" />
                                            <col />
                                            <col className="width140" />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col" colSpan={1}>수집항목</th>
                                                <th scope="col" colSpan={1}>수집방법</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">아이디, 소속기관</th>
                                                <th scope="row">㈜올포랜드 포털서비스와 시스템 연동을 통해 제공 받음</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </li>
                                <li data-no="2">
                                자동 수집 정보 (서비스 이용 기록 시)
                                <div className="table cs-table-line">
                                    <table>
                                        <colgroup>
                                            <col className="width140" />
                                            <col />
                                            <col className="width140" />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th scope="col" colSpan={1}>수집항목</th>
                                                <th scope="col" colSpan={1}>수집방법</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row">아이디, 호출한 API, 요청 시간, 응답 시간</th>
                                                <th scope="row">이용자가 회사의 AI 데이터 생성관리 서비스를 이용하는 과정에서 자동으로 수집</th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                </li>
                            </ul>
                        </section>

                        <section id="제3조">
                            <h3>제3조 (개인정보의 처리 및 보유 기간)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                인증 목적: ㈜올포랜드로부터 제공받은 개인정보(아이디, 소속기관)는 사용자가 회사의 AI 데이터 생성관리 서비스에 접속한 동안에만 일시적으로 처리되며, 서비스 접속이 종료되는 즉시 해당 정보는 시스템에서 자동으로 삭제됩니다. 별도의 보존 기간은 없습니다.
                                </li>
                                <li data-no="2">
                                서비스 운영 및 개선 목적: 서비스 이용 기록(아이디, 호출 API, 요청 시간, 응답 시간)은 수집 시점으로부터 6개월 동안 보존한 후, 서비스 개선 및 분석 목적을 달성하거나 해당 기간이 종료되면 지체없이 파기합니다.
                                </li>
                            </ul>
                        </section>

                        <section id="제4조">
                            <h3>제4조(개인정보 파기절차 및 방법)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                    회사는 원칙적으로 개인정보 처리목적이 달성된 개인정보는 지체없이 파기합니다. 다만, 다른 법령에 따라 보존하여야 하는 경우에는 그러하지 않을 수 있습니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
                                </li>
                                <li data-no="가.">
                                        파기절차
                                        <li data-no="1)">
                                        개인정보는 목적 달성 후 즉시 또는 별도의 공간에 옮겨져 내부 방침 및 기타 관련법령에 따라 일정기간 저장된 후 파기됩니다. 별도의 공간으로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 다른 목적으로 이용되지 않습니다.                                        </li>
                                        <li data-no="2)">
                                        개인정보는 처리 목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 지체 없이 파기합니다.                                        </li>
                                </li>
                                <li data-no="나.">
                                    파기방법
                                    <li data-no="1)">
                                    전자적 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                                    </li>
                                    <li data-no="2)">
                                    종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                                    </li>
                                </li>
                            </ul>
                        </section>

                        <section id="제5조">
                            <h3>제5조 (이용자의 권리·의무 및 그 행사방법)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                본 AI 데이터 생성관리 서비스는 별도의 회원가입 절차를 거치지 않고 ㈜올포랜드 포털서비스의 계정을 통해 인증하는 방식으로 운영되므로, 개인정보에 대한 열람, 정정, 삭제, 처리정지, 동의 철회 등의 권리 행사는 ㈜올포랜드 포털서비스의 관련 개인정보 처리방침에 따라 진행하실 수 있습니다. 
                                다만, AI 데이터 생성관리 서비스 이용 기록(로그)에 대해서는 회사의 개인정보 보호책임자에게 문의하여 관련 법규에 따라 권리 행사를 요청할 수 있습니다.
                                <ul className="agg-item_list2">
                                    <li data-no="가.">
                                        권리행사 방법
                                        <li data-no="1)">
                                        이메일: 서비스 제공자가 안내하는 연락처를 통해 권리 행사를 요청할 수 있습니다. 다만, 본인 확인 절차가 필요할 수 있습니다.
                                        </li>
                                    </li>
                                    <li data-no="나.">
                                        권리행사 절차
                                        <li data-no="1)">
                                        제출/신청: 정보주체는 원하는 권리(열람, 정정·삭제, 처리정지, 동의 철회)를 명확히 밝혀 이메일로 신청합니다.
                                        </li>
                                        <li data-no="2)">
                                        본인 확인: 서비스 제공자는 요청자가 본인임을 확인하기 위한 절차를 거칩니다. 신분증 사본 제출, 본인 인증 등을 요구할 수 있습니다.
                                        </li>
                                        <li data-no="3)">
                                        처리 결과 통지: 서비스 제공자는 정보주체의 요구에 따라 필요한 조치를 취한 후, 그 결과를 정보주체에게 지체 없이 통지합니다. 처리 결과 통지방법은 서면, 이메일, 전화 등 다양한 방식이 사용될 수 있습니다.
                                        </li>
                                        <li data-no="4)">
                                        이의 제기: 정보주체의 요구가 거절된 경우, 정보주체는 그 이유에 대해 이의를 제기할 수 있습니다. 이의 제기 절차는 서비스 제공자의 안내에 따릅니다.
                                        </li>
                                    </li>
                                </ul>
                                </li>
                            </ul>
                        </section>

                        
                        <section id="제6조">
                            <h3>제6조 (개인정보 보호책임자 및 담당자 연락처)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                    회사는 이용자의 개인정보를 보호하고 개인정보와 관련된 불만을 처리하기 위하여 다음과 같이 개인정보 보호책임자를 지정하고 있습니다.
                                    <div className="table cs-table-line">
                                        <table>
                                            <colgroup>
                                                <col className="width140" />
                                                <col />
                                                <col className="width140" />
                                                <col />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th scope="col" colSpan={1}>구분</th>
                                                    <th scope="col" colSpan={1}>부서명</th>
                                                    <th scope="col" colSpan={1}>성명</th>
                                                    <th scope="col" colSpan={1}>연락처(이메일)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">개인정보보호 책임자</th>
                                                    <th scope="row">Digital Twin Lab</th>
                                                    <th scope="row">전계범</th>
                                                    <th scope="row">puos033@neospectra.co.kr</th>
                                                </tr>
                                                <tr>
                                                    <th scope="row">개인정보보호 책임자</th>
                                                    <th scope="row">AI & Recon Lab</th>
                                                    <th scope="row">신수아</th>
                                                    <th scope="row">shinsua@neospectra.co.kr</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </li>

                                <li data-no="2">
                                이용자는 회사의 서비스를 이용하면서 발생하는 모든 개인정보 보호 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 개인정보 보호책임자에게 문의할 수 있습니다. 회사는 문의하신 사항에 대해 신속하고 성실하게 답변해 드릴 것입니다.
                                </li>
                            </ul>
                        </section>

                        <section id="제7조">
                            <h3>제7조 (개인정보의 안전성 확보 조치)</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">
                                회사는 이용자의 개인정보의 안전성을 확보하기 위하여 다음과 같은 조치를 취하고 있습니다.
                                <ul className="agg-item_list2">
                                        <li data-no="①">
                                        관리적 조치 : 내부관리계획 수립ㆍ시행, 정기적 직원 교육
                                        </li>
                                        <li data-no="②">
                                        기술적 조치 : 개인정보에 대한 접근 권한 관리, 접근통제시스템 설치, 암호화 조치 (전송 구간), 보안 프로그램 설치 및 정기적인 점검, 로그 기록 시스템 보안 강화
                                        </li>
                                        <li data-no="③">
                                        물리적 조치 : 전산실, 자료보관실 등 접근 통제 (해당하는 경우)
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </section>
                        
                        <section id="제8조">
                            <h3>제8조(정보주체의 권익침해에 대한 구제방법)</h3>
                            <ul className="agg-item_list2">
                                <li data-no="①">
                                    개인정보주체는 개인정보침해로 인한 피해를 구제받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원 개인정보 침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
                                </li>
                                아래의 기관은 법제처와는 별개의 기관으로서, 법제처의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다 자세한 도움이 필요하시면 문의하여 주시기 바랍니다.<br/>
                                ☞ 개인정보 분쟁조정위원회 : 1833-6972 (www.kopico.go.kr) <br/>
                                ☞ 개인정보 침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr) <br/>
                                ☞ 대검찰청 사이버수사과 : (국번없이) 1301, privacy@spo.go.kr, (www.spo.go.kr) <br/>
                                ☞ 경찰청 사이버안전국 : (국번없이) 182, (cyberbureau.police.go.kr) <br/>
                                <li data-no="②"> 
                                    개인정보주체는 개인정보침해로 인한 피해를 구제받기 위하여 개인정보 분쟁조정위원회, 한국인터넷진흥원 개인정보 침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
                                </li>
                                <li data-no="③">
                                    「개인정보 보호법」제35조(개인정보의열람), 제36조(개인정보의 정정ㆍ삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.<br/>
                                    ※ 중앙행정심판위원회 : (국번없이) 110 (http://www.simpan.go.kr)

                                </li>
                            </ul>
                        </section>

                        <section id="제9조">
                            <h3>제9조 (개인정보 처리방침 변경)</h3>
                            
                            <ul className="agg-item_list2">
                                <li data-no="①">
                                    본 개인정보 처리방침은 법률 및 서비스 변경 사항, 내부 정책 변경 등에 따라 변경될 수 있으며, 변경될 경우에는 변경 사항 시행일 7일 전부터 웹사이트 또는 앱 등을 통해 공지하도록 하겠습니다. 
                                </li>
                                <li data-no="②"> 
                                    다만, 이용자에게 불리하게 변경되는 경우에는 30일 전부터 공지합니다.
                                </li>
                            </ul>
                        </section>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default NeospectraPrivacy;